module.exports = __webpack_public_path__ + "static/media/woodBadge.022384b5.png";